//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// *** MUI / STYLE ***
import { useTheme } from '@mui/material/styles';
import { Paper, Card, CardHeader, CardContent, Box } from '@mui/material';

// === API ===
import { mergeDocumentAtPageNumber, onImage, onImageFocus, removeListener, requestImage, resetImage, setMainImage, splitDocumentAtPageNumber } from 'api/prokey/prokey.websocket';
import { prokeyApi } from 'api/prokey';

// === COMPONENTS ===
// import { TaskContext } from '../../../TaskContext/TaskContext';

//#endregion

//-----------------------------------------------------------------
export function Thumbnail({ id, image }) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const myRef = React.useRef();

  // const [ image       , setImage    ] = useState( null  );
  const [ is_selected , setSelected ] = useState( false );
  const has_image = !!image;

  const url = image ? image.url : '';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      borderStyle  : is_selected ? 'solid' : 'none' ,
      borderColor  : theme.palette.primary.main ,
      borderWidth  : is_selected ? '5px'    : 0 ,
      borderRadius : is_selected ? '0.5rem' : 0 ,
      display: 'flex',
      justifyContent: 'center',
      margin: '1rem',
      // alignItems: 'center',
      // maxWidth     : '100%'   ,
      // maxHeight    : '250px'  ,
    },
    thumbnail: {
      maxWidth     : '100%'   ,
      maxHeight    : '250px'  ,
    },
  }

  const
    CONTAINER = {
      sx: _styles.container,
      tabIndex: id,
      onClick : () => setMainImage( image ),
      onKeyDown: handleKeyDown,
    },
    THUMBNAIL = {
      component : 'img',
      sx        : _styles.thumbnail,
      src       : url    ,
      ref       : myRef  ,
      alt       : ''     ,
      key       : id     ,
      loading   : 'lazy' ,
      selected  : is_selected,
      // className : 'pdThumb ' + (selected ? 'selected' : '') ,
      onLoad: (e)=>{
        if(is_selected) {
          myRef.current.scrollIntoView({behavior: 'auto'});
        }
      },
      onError: (event) => {
        // if( id === 0 ) console.log( {url: image.url} );
        resetImage( id, image.s3 );
      }
    };

  //#endregion

  //#region [EFFECT]

  useLayoutEffect( () => {
    if(is_selected && myRef.current) {
      myRef.current.scrollIntoView({behavior: 'auto', block: 'nearest'});
    }
  });


  useEffect( () => {
    return;
    //-----------------------------------------------------------------
    function handleImage(data) {
      //-----------------------------------------------------------------
      // setImage(data)
    }
    //-----------------------------------------------------------------
    function handleImageFocus(data) {
      //-----------------------------------------------------------------
      // const value = data.clear ? false : true;
      // setSelected( value );
    }

    onImage     ( id , handleImage      );
    onImageFocus( id , handleImageFocus );

    requestImage( id );
    return () => {
      removeListener( 'IMAGE-'      + id, handleImage      );
      removeListener( 'IMAGE-FOCUS' + id, handleImageFocus );
    }
  }, [] );

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleKeyDown(e) {
    //-----------------------------------------------------------------
    if(is_selected) {
      const is_split = e.key === 's';
      const is_merge = e.key === 'm';
           if( is_split ) splitDocumentAtPageNumber( id );
      else if( is_merge ) mergeDocumentAtPageNumber( id );
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return has_image ? (
      <Box { ...CONTAINER } >
        <Box { ...THUMBNAIL } />
      </Box>
    ) : (
      <Box>Loading...</Box>
    )
  }

  //#endregion

  return display();
};